export default __webpack_public_path__ + "static/media/notification&sos.471db947.svg";